import { render } from "./CreateFacilityGroup.vue?vue&type=template&id=8dd8c4f6&scoped=true&ts=true"
import script from "./CreateFacilityGroup.vue?vue&type=script&lang=ts"
export * from "./CreateFacilityGroup.vue?vue&type=script&lang=ts"

import "./CreateFacilityGroup.vue?vue&type=style&index=0&id=8dd8c4f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd8c4f6"]])

export default __exports__